export default "__VITE_ASSET__CIJQMzu3__"